import React from 'react';

import {Emblem} from './Emblem.jsx';
import {BreadCrumb} from './BreadCrumb.jsx';
import {MarketplaceButton} from './MarketplaceButton.jsx';
import {GearButton} from './GearButton.jsx';

var NavigationBar = React.createClass({
    render: function(){
      return(
        <section className="top-bar clearfix">
          <Emblem />
          <BreadCrumb libName = {this.props.libName}/>
            <div className="buttons">
             {/*<MarketplaceButton />*/}
             <GearButton />
            </div>
        </section>
        );
    }
});

export {NavigationBar};


/** WEBPACK FOOTER **
 ** ./html/components/NavigationBar.jsx
 **/